/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddPunchConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { AuditResponse } from '../api-models';
// @ts-ignore
import { ExceptionResponseV2 } from '../api-models';
// @ts-ignore
import { MissingPunchResponseV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { PunchAddRequestV2 } from '../api-models';
// @ts-ignore
import { PunchCommentDeleteRequestV2 } from '../api-models';
// @ts-ignore
import { PunchCommentUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { PunchDeleteRequestV2 } from '../api-models';
// @ts-ignore
import { PunchDetailedAddRequestV2 } from '../api-models';
// @ts-ignore
import { PunchDetailedResponseV2 } from '../api-models';
// @ts-ignore
import { PunchDetailedUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { PunchMultiAddRequestV2 } from '../api-models';
// @ts-ignore
import { PunchMultiDeleteRequestV2 } from '../api-models';
// @ts-ignore
import { PunchResponseV2 } from '../api-models';
// @ts-ignore
import { PunchUpdateRequestV2 } from '../api-models';
/**
 * PunchV2Api - axios parameter creator
 * @export
 */
export const PunchV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns defaults and date constraints for the Add Punch dialog. Replaces taApi  `GET /api/Punch/AddPunchConfiguration`.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {boolean} [isOutPunchColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchAddConfigurationGet: async (employeeId: number, payDate: string, isOutPunchColumn?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2PunchAddConfigurationGet', 'employeeId', employeeId)
            // verify required parameter 'payDate' is not null or undefined
            assertParamExists('apiV2PunchAddConfigurationGet', 'payDate', payDate)
            const localVarPath = `/api/v2/punch/add-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (isOutPunchColumn !== undefined) {
                localVarQueryParameter['isOutPunchColumn'] = isOutPunchColumn;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit trail for one punch row, or 204 when the punch doesn\'t belong to the  employee or has no audits. Replaces taApi `GET /api/Punch/PunchAudits`.
         * @param {number} employeeId 
         * @param {number} punchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchAuditsGet: async (employeeId: number, punchId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2PunchAuditsGet', 'employeeId', employeeId)
            // verify required parameter 'punchId' is not null or undefined
            assertParamExists('apiV2PunchAuditsGet', 'punchId', punchId)
            const localVarPath = `/api/v2/punch/audits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (punchId !== undefined) {
                localVarQueryParameter['punchId'] = punchId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the comment on a punch. Replaces taApi `DELETE /api/Punch/Comment`.
         * @param {PunchCommentDeleteRequestV2} [punchCommentDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchCommentDelete: async (punchCommentDeleteRequestV2?: PunchCommentDeleteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchCommentDeleteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set/append the comment on a punch. Replaces taApi `PUT /api/Punch/Comment`.
         * @param {PunchCommentUpdateRequestV2} [punchCommentUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchCommentPut: async (punchCommentUpdateRequestV2?: PunchCommentUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchCommentUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Intentional, authorized divergence from TaAPI: SaaSAPI gates the punch write paths  (delete here, and add on M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchAddRequestV2,System.Threading.CancellationToken)/M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddDetailedPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchDetailedAddRequestV2,System.Threading.CancellationToken))  on the typed `role.PunchDelete` / `role.PunchAdd` permissions — faithful to the  LegacyApp WinApp (TimeCardsControl gates delete via `role.GetPunchDelete`). TaAPI dropped  these UI-layer gates in its REST service port and returns 200 for a permission-less caller, so  SaaSAPI returns 403 where TaAPI returns 200. This is the stricter (safer) behaviour and the  source-of-truth WinApp semantics; the 403-vs-200 status divergence is accepted by design.
         * @summary Soft-delete one punch. Replaces taApi `DELETE /api/Punch`.
         * @param {PunchDeleteRequestV2} [punchDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDelete: async (punchDeleteRequestV2?: PunchDeleteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchDeleteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the full editable detail of one punch row, or 204 when no such punch exists for  the supplied employee. Replaces taApi `GET /api/Punch/PunchDetails`.
         * @param {number} employeeId 
         * @param {number} punchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDetailsGet: async (employeeId: number, punchId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2PunchDetailsGet', 'employeeId', employeeId)
            // verify required parameter 'punchId' is not null or undefined
            assertParamExists('apiV2PunchDetailsGet', 'punchId', punchId)
            const localVarPath = `/api/v2/punch/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (punchId !== undefined) {
                localVarQueryParameter['punchId'] = punchId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update full override surface on an existing punch. Replaces taApi  `PUT /api/Punch/PunchDetails` AND the typo\'d `PunchDeatils` alias —  frontends from the legacy taApi era may hard-code either spelling, so both routes  resolve to the same handler. The typo alias forwards to the canonical route.
         * @param {PunchDetailedUpdateRequestV2} [punchDetailedUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDetailsPut: async (punchDetailedUpdateRequestV2?: PunchDetailedUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchDetailedUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the employee\'s exceptions in the supplied range. Replaces taApi  `GET /api/Exceptions` (which was hosted on the legacy PunchController for  historical reasons).
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchExceptionsGet: async (employeeId: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2PunchExceptionsGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/punch/exceptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the employee\'s punches in the supplied range (working pay period when  null). Replaces taApi `GET /api/Punch/Punches` (and the obsolete  `GET /api/Punch`).
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchGet: async (employeeId: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2PunchGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List \"missing punches\" — TimeCards with one missing pair. Replaces taApi  `GET /api/Punch/MissingPunches`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMissingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete multiple punches. Replaces taApi `DELETE /api/Punch/Punches`.
         * @param {PunchMultiDeleteRequestV2} [punchMultiDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMultiDelete: async (punchMultiDeleteRequestV2?: PunchMultiDeleteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/multi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchMultiDeleteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds multiple punches for a single employee in one batch.
         * @param {PunchMultiAddRequestV2} [punchMultiAddRequestV2] The batch of punches to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMultiPost: async (punchMultiAddRequestV2?: PunchMultiAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/multi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchMultiAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add one punch. Replaces taApi `POST /api/Punch`.
         * @param {PunchAddRequestV2} [punchAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchPost: async (punchAddRequestV2?: PunchAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update date+type on an existing punch. Replaces taApi `PUT /api/Punch`.
         * @param {PunchUpdateRequestV2} [punchUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchPut: async (punchUpdateRequestV2?: PunchUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a punch with full overrides. Replaces taApi `POST /api/Punch/PunchWithDetails`.
         * @param {PunchDetailedAddRequestV2} [punchDetailedAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchWithDetailsPost: async (punchDetailedAddRequestV2?: PunchDetailedAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/punch/with-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(punchDetailedAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PunchV2Api - functional programming interface
 * @export
 */
export const PunchV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PunchV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns defaults and date constraints for the Add Punch dialog. Replaces taApi  `GET /api/Punch/AddPunchConfiguration`.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {boolean} [isOutPunchColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchAddConfigurationGet(employeeId: number, payDate: string, isOutPunchColumn?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPunchConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchAddConfigurationGet(employeeId, payDate, isOutPunchColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit trail for one punch row, or 204 when the punch doesn\'t belong to the  employee or has no audits. Replaces taApi `GET /api/Punch/PunchAudits`.
         * @param {number} employeeId 
         * @param {number} punchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchAuditsGet(employeeId: number, punchId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchAuditsGet(employeeId, punchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete the comment on a punch. Replaces taApi `DELETE /api/Punch/Comment`.
         * @param {PunchCommentDeleteRequestV2} [punchCommentDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchCommentDelete(punchCommentDeleteRequestV2?: PunchCommentDeleteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchCommentDelete(punchCommentDeleteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set/append the comment on a punch. Replaces taApi `PUT /api/Punch/Comment`.
         * @param {PunchCommentUpdateRequestV2} [punchCommentUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchCommentPut(punchCommentUpdateRequestV2?: PunchCommentUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchCommentPut(punchCommentUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Intentional, authorized divergence from TaAPI: SaaSAPI gates the punch write paths  (delete here, and add on M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchAddRequestV2,System.Threading.CancellationToken)/M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddDetailedPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchDetailedAddRequestV2,System.Threading.CancellationToken))  on the typed `role.PunchDelete` / `role.PunchAdd` permissions — faithful to the  LegacyApp WinApp (TimeCardsControl gates delete via `role.GetPunchDelete`). TaAPI dropped  these UI-layer gates in its REST service port and returns 200 for a permission-less caller, so  SaaSAPI returns 403 where TaAPI returns 200. This is the stricter (safer) behaviour and the  source-of-truth WinApp semantics; the 403-vs-200 status divergence is accepted by design.
         * @summary Soft-delete one punch. Replaces taApi `DELETE /api/Punch`.
         * @param {PunchDeleteRequestV2} [punchDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchDelete(punchDeleteRequestV2?: PunchDeleteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchDelete(punchDeleteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the full editable detail of one punch row, or 204 when no such punch exists for  the supplied employee. Replaces taApi `GET /api/Punch/PunchDetails`.
         * @param {number} employeeId 
         * @param {number} punchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchDetailsGet(employeeId: number, punchId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchDetailsGet(employeeId, punchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update full override surface on an existing punch. Replaces taApi  `PUT /api/Punch/PunchDetails` AND the typo\'d `PunchDeatils` alias —  frontends from the legacy taApi era may hard-code either spelling, so both routes  resolve to the same handler. The typo alias forwards to the canonical route.
         * @param {PunchDetailedUpdateRequestV2} [punchDetailedUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchDetailsPut(punchDetailedUpdateRequestV2?: PunchDetailedUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchDetailsPut(punchDetailedUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List the employee\'s exceptions in the supplied range. Replaces taApi  `GET /api/Exceptions` (which was hosted on the legacy PunchController for  historical reasons).
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchExceptionsGet(employeeId: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExceptionResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchExceptionsGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List the employee\'s punches in the supplied range (working pay period when  null). Replaces taApi `GET /api/Punch/Punches` (and the obsolete  `GET /api/Punch`).
         * @param {number} employeeId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchGet(employeeId: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PunchResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchGet(employeeId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List \"missing punches\" — TimeCards with one missing pair. Replaces taApi  `GET /api/Punch/MissingPunches`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchMissingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MissingPunchResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchMissingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete multiple punches. Replaces taApi `DELETE /api/Punch/Punches`.
         * @param {PunchMultiDeleteRequestV2} [punchMultiDeleteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchMultiDelete(punchMultiDeleteRequestV2?: PunchMultiDeleteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchMultiDelete(punchMultiDeleteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds multiple punches for a single employee in one batch.
         * @param {PunchMultiAddRequestV2} [punchMultiAddRequestV2] The batch of punches to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchMultiPost(punchMultiAddRequestV2?: PunchMultiAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PunchDetailedResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchMultiPost(punchMultiAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add one punch. Replaces taApi `POST /api/Punch`.
         * @param {PunchAddRequestV2} [punchAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchPost(punchAddRequestV2?: PunchAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchPost(punchAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update date+type on an existing punch. Replaces taApi `PUT /api/Punch`.
         * @param {PunchUpdateRequestV2} [punchUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchPut(punchUpdateRequestV2?: PunchUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchPut(punchUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a punch with full overrides. Replaces taApi `POST /api/Punch/PunchWithDetails`.
         * @param {PunchDetailedAddRequestV2} [punchDetailedAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchWithDetailsPost(punchDetailedAddRequestV2?: PunchDetailedAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchDetailedResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchWithDetailsPost(punchDetailedAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PunchV2Api - factory interface
 * @export
 */
export const PunchV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PunchV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns defaults and date constraints for the Add Punch dialog. Replaces taApi  `GET /api/Punch/AddPunchConfiguration`.
         * @param {PunchV2ApiApiV2PunchAddConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchAddConfigurationGet(requestParameters: PunchV2ApiApiV2PunchAddConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<AddPunchConfigurationResponseV2> {
            return localVarFp.apiV2PunchAddConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.isOutPunchColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit trail for one punch row, or 204 when the punch doesn\'t belong to the  employee or has no audits. Replaces taApi `GET /api/Punch/PunchAudits`.
         * @param {PunchV2ApiApiV2PunchAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchAuditsGet(requestParameters: PunchV2ApiApiV2PunchAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2PunchAuditsGet(requestParameters.employeeId, requestParameters.punchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the comment on a punch. Replaces taApi `DELETE /api/Punch/Comment`.
         * @param {PunchV2ApiApiV2PunchCommentDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchCommentDelete(requestParameters: PunchV2ApiApiV2PunchCommentDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchCommentDelete(requestParameters.punchCommentDeleteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set/append the comment on a punch. Replaces taApi `PUT /api/Punch/Comment`.
         * @param {PunchV2ApiApiV2PunchCommentPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchCommentPut(requestParameters: PunchV2ApiApiV2PunchCommentPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchCommentPut(requestParameters.punchCommentUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Intentional, authorized divergence from TaAPI: SaaSAPI gates the punch write paths  (delete here, and add on M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchAddRequestV2,System.Threading.CancellationToken)/M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddDetailedPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchDetailedAddRequestV2,System.Threading.CancellationToken))  on the typed `role.PunchDelete` / `role.PunchAdd` permissions — faithful to the  LegacyApp WinApp (TimeCardsControl gates delete via `role.GetPunchDelete`). TaAPI dropped  these UI-layer gates in its REST service port and returns 200 for a permission-less caller, so  SaaSAPI returns 403 where TaAPI returns 200. This is the stricter (safer) behaviour and the  source-of-truth WinApp semantics; the 403-vs-200 status divergence is accepted by design.
         * @summary Soft-delete one punch. Replaces taApi `DELETE /api/Punch`.
         * @param {PunchV2ApiApiV2PunchDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDelete(requestParameters: PunchV2ApiApiV2PunchDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchDelete(requestParameters.punchDeleteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the full editable detail of one punch row, or 204 when no such punch exists for  the supplied employee. Replaces taApi `GET /api/Punch/PunchDetails`.
         * @param {PunchV2ApiApiV2PunchDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDetailsGet(requestParameters: PunchV2ApiApiV2PunchDetailsGetRequest, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchDetailsGet(requestParameters.employeeId, requestParameters.punchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update full override surface on an existing punch. Replaces taApi  `PUT /api/Punch/PunchDetails` AND the typo\'d `PunchDeatils` alias —  frontends from the legacy taApi era may hard-code either spelling, so both routes  resolve to the same handler. The typo alias forwards to the canonical route.
         * @param {PunchV2ApiApiV2PunchDetailsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchDetailsPut(requestParameters: PunchV2ApiApiV2PunchDetailsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchDetailsPut(requestParameters.punchDetailedUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the employee\'s exceptions in the supplied range. Replaces taApi  `GET /api/Exceptions` (which was hosted on the legacy PunchController for  historical reasons).
         * @param {PunchV2ApiApiV2PunchExceptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchExceptionsGet(requestParameters: PunchV2ApiApiV2PunchExceptionsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ExceptionResponseV2>> {
            return localVarFp.apiV2PunchExceptionsGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the employee\'s punches in the supplied range (working pay period when  null). Replaces taApi `GET /api/Punch/Punches` (and the obsolete  `GET /api/Punch`).
         * @param {PunchV2ApiApiV2PunchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchGet(requestParameters: PunchV2ApiApiV2PunchGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PunchResponseV2>> {
            return localVarFp.apiV2PunchGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List \"missing punches\" — TimeCards with one missing pair. Replaces taApi  `GET /api/Punch/MissingPunches`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMissingGet(options?: AxiosRequestConfig): AxiosPromise<Array<MissingPunchResponseV2>> {
            return localVarFp.apiV2PunchMissingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete multiple punches. Replaces taApi `DELETE /api/Punch/Punches`.
         * @param {PunchV2ApiApiV2PunchMultiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMultiDelete(requestParameters: PunchV2ApiApiV2PunchMultiDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2PunchMultiDelete(requestParameters.punchMultiDeleteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds multiple punches for a single employee in one batch.
         * @param {PunchV2ApiApiV2PunchMultiPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchMultiPost(requestParameters: PunchV2ApiApiV2PunchMultiPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<PunchDetailedResponseV2>> {
            return localVarFp.apiV2PunchMultiPost(requestParameters.punchMultiAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add one punch. Replaces taApi `POST /api/Punch`.
         * @param {PunchV2ApiApiV2PunchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchPost(requestParameters: PunchV2ApiApiV2PunchPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchPost(requestParameters.punchAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update date+type on an existing punch. Replaces taApi `PUT /api/Punch`.
         * @param {PunchV2ApiApiV2PunchPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchPut(requestParameters: PunchV2ApiApiV2PunchPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchPut(requestParameters.punchUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a punch with full overrides. Replaces taApi `POST /api/Punch/PunchWithDetails`.
         * @param {PunchV2ApiApiV2PunchWithDetailsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchWithDetailsPost(requestParameters: PunchV2ApiApiV2PunchWithDetailsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PunchDetailedResponseV2> {
            return localVarFp.apiV2PunchWithDetailsPost(requestParameters.punchDetailedAddRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2PunchAddConfigurationGet operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchAddConfigurationGetRequest
 */
export interface PunchV2ApiApiV2PunchAddConfigurationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchAddConfigurationGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof PunchV2ApiApiV2PunchAddConfigurationGet
     */
    readonly payDate: string

    /**
     * 
     * @type {boolean}
     * @memberof PunchV2ApiApiV2PunchAddConfigurationGet
     */
    readonly isOutPunchColumn?: boolean
}

/**
 * Request parameters for apiV2PunchAuditsGet operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchAuditsGetRequest
 */
export interface PunchV2ApiApiV2PunchAuditsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchAuditsGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchAuditsGet
     */
    readonly punchId: number
}

/**
 * Request parameters for apiV2PunchCommentDelete operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchCommentDeleteRequest
 */
export interface PunchV2ApiApiV2PunchCommentDeleteRequest {
    /**
     * 
     * @type {PunchCommentDeleteRequestV2}
     * @memberof PunchV2ApiApiV2PunchCommentDelete
     */
    readonly punchCommentDeleteRequestV2?: PunchCommentDeleteRequestV2
}

/**
 * Request parameters for apiV2PunchCommentPut operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchCommentPutRequest
 */
export interface PunchV2ApiApiV2PunchCommentPutRequest {
    /**
     * 
     * @type {PunchCommentUpdateRequestV2}
     * @memberof PunchV2ApiApiV2PunchCommentPut
     */
    readonly punchCommentUpdateRequestV2?: PunchCommentUpdateRequestV2
}

/**
 * Request parameters for apiV2PunchDelete operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchDeleteRequest
 */
export interface PunchV2ApiApiV2PunchDeleteRequest {
    /**
     * 
     * @type {PunchDeleteRequestV2}
     * @memberof PunchV2ApiApiV2PunchDelete
     */
    readonly punchDeleteRequestV2?: PunchDeleteRequestV2
}

/**
 * Request parameters for apiV2PunchDetailsGet operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchDetailsGetRequest
 */
export interface PunchV2ApiApiV2PunchDetailsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchDetailsGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchDetailsGet
     */
    readonly punchId: number
}

/**
 * Request parameters for apiV2PunchDetailsPut operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchDetailsPutRequest
 */
export interface PunchV2ApiApiV2PunchDetailsPutRequest {
    /**
     * 
     * @type {PunchDetailedUpdateRequestV2}
     * @memberof PunchV2ApiApiV2PunchDetailsPut
     */
    readonly punchDetailedUpdateRequestV2?: PunchDetailedUpdateRequestV2
}

/**
 * Request parameters for apiV2PunchExceptionsGet operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchExceptionsGetRequest
 */
export interface PunchV2ApiApiV2PunchExceptionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchExceptionsGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof PunchV2ApiApiV2PunchExceptionsGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof PunchV2ApiApiV2PunchExceptionsGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiV2PunchGet operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchGetRequest
 */
export interface PunchV2ApiApiV2PunchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchV2ApiApiV2PunchGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof PunchV2ApiApiV2PunchGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof PunchV2ApiApiV2PunchGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for apiV2PunchMultiDelete operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchMultiDeleteRequest
 */
export interface PunchV2ApiApiV2PunchMultiDeleteRequest {
    /**
     * 
     * @type {PunchMultiDeleteRequestV2}
     * @memberof PunchV2ApiApiV2PunchMultiDelete
     */
    readonly punchMultiDeleteRequestV2?: PunchMultiDeleteRequestV2
}

/**
 * Request parameters for apiV2PunchMultiPost operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchMultiPostRequest
 */
export interface PunchV2ApiApiV2PunchMultiPostRequest {
    /**
     * The batch of punches to add.
     * @type {PunchMultiAddRequestV2}
     * @memberof PunchV2ApiApiV2PunchMultiPost
     */
    readonly punchMultiAddRequestV2?: PunchMultiAddRequestV2
}

/**
 * Request parameters for apiV2PunchPost operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchPostRequest
 */
export interface PunchV2ApiApiV2PunchPostRequest {
    /**
     * 
     * @type {PunchAddRequestV2}
     * @memberof PunchV2ApiApiV2PunchPost
     */
    readonly punchAddRequestV2?: PunchAddRequestV2
}

/**
 * Request parameters for apiV2PunchPut operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchPutRequest
 */
export interface PunchV2ApiApiV2PunchPutRequest {
    /**
     * 
     * @type {PunchUpdateRequestV2}
     * @memberof PunchV2ApiApiV2PunchPut
     */
    readonly punchUpdateRequestV2?: PunchUpdateRequestV2
}

/**
 * Request parameters for apiV2PunchWithDetailsPost operation in PunchV2Api.
 * @export
 * @interface PunchV2ApiApiV2PunchWithDetailsPostRequest
 */
export interface PunchV2ApiApiV2PunchWithDetailsPostRequest {
    /**
     * 
     * @type {PunchDetailedAddRequestV2}
     * @memberof PunchV2ApiApiV2PunchWithDetailsPost
     */
    readonly punchDetailedAddRequestV2?: PunchDetailedAddRequestV2
}

/**
 * PunchV2Api - object-oriented interface
 * @export
 * @class PunchV2Api
 * @extends {BaseAPI}
 */
export class PunchV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns defaults and date constraints for the Add Punch dialog. Replaces taApi  `GET /api/Punch/AddPunchConfiguration`.
     * @param {PunchV2ApiApiV2PunchAddConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchAddConfigurationGet(requestParameters: PunchV2ApiApiV2PunchAddConfigurationGetRequest, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchAddConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.isOutPunchColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit trail for one punch row, or 204 when the punch doesn\'t belong to the  employee or has no audits. Replaces taApi `GET /api/Punch/PunchAudits`.
     * @param {PunchV2ApiApiV2PunchAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchAuditsGet(requestParameters: PunchV2ApiApiV2PunchAuditsGetRequest, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchAuditsGet(requestParameters.employeeId, requestParameters.punchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the comment on a punch. Replaces taApi `DELETE /api/Punch/Comment`.
     * @param {PunchV2ApiApiV2PunchCommentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchCommentDelete(requestParameters: PunchV2ApiApiV2PunchCommentDeleteRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchCommentDelete(requestParameters.punchCommentDeleteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set/append the comment on a punch. Replaces taApi `PUT /api/Punch/Comment`.
     * @param {PunchV2ApiApiV2PunchCommentPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchCommentPut(requestParameters: PunchV2ApiApiV2PunchCommentPutRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchCommentPut(requestParameters.punchCommentUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Intentional, authorized divergence from TaAPI: SaaSAPI gates the punch write paths  (delete here, and add on M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchAddRequestV2,System.Threading.CancellationToken)/M:OpenShifts.WebApi.Controllers.PunchV2Controller.AddDetailedPunchAsync(OpenShifts.BusinessObjects.Request.Punch.PunchDetailedAddRequestV2,System.Threading.CancellationToken))  on the typed `role.PunchDelete` / `role.PunchAdd` permissions — faithful to the  LegacyApp WinApp (TimeCardsControl gates delete via `role.GetPunchDelete`). TaAPI dropped  these UI-layer gates in its REST service port and returns 200 for a permission-less caller, so  SaaSAPI returns 403 where TaAPI returns 200. This is the stricter (safer) behaviour and the  source-of-truth WinApp semantics; the 403-vs-200 status divergence is accepted by design.
     * @summary Soft-delete one punch. Replaces taApi `DELETE /api/Punch`.
     * @param {PunchV2ApiApiV2PunchDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchDelete(requestParameters: PunchV2ApiApiV2PunchDeleteRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchDelete(requestParameters.punchDeleteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the full editable detail of one punch row, or 204 when no such punch exists for  the supplied employee. Replaces taApi `GET /api/Punch/PunchDetails`.
     * @param {PunchV2ApiApiV2PunchDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchDetailsGet(requestParameters: PunchV2ApiApiV2PunchDetailsGetRequest, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchDetailsGet(requestParameters.employeeId, requestParameters.punchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update full override surface on an existing punch. Replaces taApi  `PUT /api/Punch/PunchDetails` AND the typo\'d `PunchDeatils` alias —  frontends from the legacy taApi era may hard-code either spelling, so both routes  resolve to the same handler. The typo alias forwards to the canonical route.
     * @param {PunchV2ApiApiV2PunchDetailsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchDetailsPut(requestParameters: PunchV2ApiApiV2PunchDetailsPutRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchDetailsPut(requestParameters.punchDetailedUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the employee\'s exceptions in the supplied range. Replaces taApi  `GET /api/Exceptions` (which was hosted on the legacy PunchController for  historical reasons).
     * @param {PunchV2ApiApiV2PunchExceptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchExceptionsGet(requestParameters: PunchV2ApiApiV2PunchExceptionsGetRequest, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchExceptionsGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the employee\'s punches in the supplied range (working pay period when  null). Replaces taApi `GET /api/Punch/Punches` (and the obsolete  `GET /api/Punch`).
     * @param {PunchV2ApiApiV2PunchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchGet(requestParameters: PunchV2ApiApiV2PunchGetRequest, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchGet(requestParameters.employeeId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List \"missing punches\" — TimeCards with one missing pair. Replaces taApi  `GET /api/Punch/MissingPunches`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchMissingGet(options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchMissingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete multiple punches. Replaces taApi `DELETE /api/Punch/Punches`.
     * @param {PunchV2ApiApiV2PunchMultiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchMultiDelete(requestParameters: PunchV2ApiApiV2PunchMultiDeleteRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchMultiDelete(requestParameters.punchMultiDeleteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds multiple punches for a single employee in one batch.
     * @param {PunchV2ApiApiV2PunchMultiPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchMultiPost(requestParameters: PunchV2ApiApiV2PunchMultiPostRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchMultiPost(requestParameters.punchMultiAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add one punch. Replaces taApi `POST /api/Punch`.
     * @param {PunchV2ApiApiV2PunchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchPost(requestParameters: PunchV2ApiApiV2PunchPostRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchPost(requestParameters.punchAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update date+type on an existing punch. Replaces taApi `PUT /api/Punch`.
     * @param {PunchV2ApiApiV2PunchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchPut(requestParameters: PunchV2ApiApiV2PunchPutRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchPut(requestParameters.punchUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a punch with full overrides. Replaces taApi `POST /api/Punch/PunchWithDetails`.
     * @param {PunchV2ApiApiV2PunchWithDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchV2Api
     */
    public apiV2PunchWithDetailsPost(requestParameters: PunchV2ApiApiV2PunchWithDetailsPostRequest = {}, options?: AxiosRequestConfig) {
        return PunchV2ApiFp(this.configuration).apiV2PunchWithDetailsPost(requestParameters.punchDetailedAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}
